import React from 'react';
import { B } from '../constants';

export const POST_REEL_TAGLINE = 'Your camera roll has jet lag. Let those trip clips out.';

export default function ReelsPostButton({ onClick }) {
  return (
    <div className="reels-post-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, margin: '0 auto 24px', textAlign: 'center' }}>
      <button onClick={onClick}
        className="reels-post-btn"
        style={{
          background: `linear-gradient(135deg,${B.amber},#ff8c00)`, color: B.night,
          border: 'none', padding: '12px 26px', borderRadius: 50, cursor: 'pointer',
          fontFamily: "'Montserrat',sans-serif", fontSize: 14, fontWeight: 800,
          whiteSpace: 'nowrap', boxShadow: '0 4px 16px rgba(245,166,35,0.4)',
        }}>
        🧳 Post a Reel
      </button>
      <span style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 12, color: 'var(--reels-muted, #5b6470)' }}>{POST_REEL_TAGLINE}</span>
    </div>
  );
}
